import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'text-label',
  templateUrl: './text-label.component.html',
  styleUrls: ['./text-label.component.css']
})
export class TextLabelComponent implements OnInit {
  @Input() name: string;
  @Input() label: string;
  @Input() className: string;

  constructor() {}

  ngOnInit() {}
}
